import { render, staticRenderFns } from "./AdminCalendarComponent.vue?vue&type=template&id=1c47bf4c&scoped=true&"
import script from "./AdminCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./AdminCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminCalendarComponent.vue?vue&type=style&index=0&id=1c47bf4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47bf4c",
  null
  
)

export default component.exports